<template>
  <div class="premium-page">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-md-8">
          <div class="premium-header">
            <div class="premium-thumbs">
              <b-img src="/img/thumbs-up.png"/>
            </div>
            <div class="premium-title">
              <h6>curtiu o QUEOTA.club?</h6>
              <h1>Com PREMIUM é muito melhor</h1>
            </div>
          </div>
          <div class="premium-box">
            <p
              class="lead"
            >Sendo premium, além de apoiar o nosso desenvolvimento você tem acesso aos seguintes recursos</p>

            <div class="lead">
              <ul>
                <li>Lobbies no modo treino (30 rounds jogados)</li>
                <li>GOTV liberada em suas partidas</li>
                <li>Servidores privados para treino</li>
                <li>50% de desconto no FIGHTBACK.club</li>
                <li>Criação de Clubs</li>
                <li>Acesso beta a todas as novas funcionalidades</li>
              </ul>
            </div>

            <div class="text-center">
              <b-btn
                variant="success"
                :to="{ name: 'AccountDashboard' }"
                size="lg"
              >Assine agora por R$ 24,99</b-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PremiumPage",
  data() {
    return {};
  },
  methods: {
    initialize() {}
  },
  mounted() {
    this.initialize();
  },
  components: {}
};
</script>

<style lang="sass" scoped>
.premium-page
  padding-top: 80px
  .premium-header
    position: relative
    margin-top: 40px

    .premium-thumbs
      position: absolute
      right: 0
      bottom: -20px
      img
        height: auto
        width: 370px

    .premium-title
      margin: 20px 0
      position: relative
      z-index: 3
    
  .premium-box
    background: rgba(0, 0, 0, .3)
    padding: 20px
    border-radius: 4px
</style>
